<template>



  <!--  ==============================  MODAL_SECTION START ============================== -->
  <b-modal
    id="modal-add-place-of-work"
    :title="editMode == true ?  $t('edition') : $t('add_place_of_work')"
    cancel-variant="outline-secondary"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @cancel="onCancel"
    @close="onCancel"
    @show="showModal"
    @ok="onSubmitMoney"
  >
    <b-form>
      <validation-observer ref="placeOfWorkValidations">

        <b-tabs content-class="pt-1" fill>
          <b-tab active :title="$t('reference.name') + ' uz'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <b-form-input v-model="title.uz" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('reference.name') + ' ru'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <b-form-input v-model="title.ru" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>

      </validation-observer>
    </b-form>
  </b-modal>
  <!--  ==============================  MODAL_SECTION END ============================== -->




  
</template>

<script>
import { BModal, VBModal, BForm, BFormInput, BFormGroup, BFormFile, BTabs, BTab } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required } from "@core/utils/validations/validations";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormFile,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BTabs,
    BTab,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editPlaceOfWork: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      title: {ru: '', uz: ''},
      editMode: false,
      // ===============  PRIMARY_DATA_SECTION END ===============




    };
  },
  methods: {
    ...mapActions("placeOfWork", [
      "CREATE_PLACE_OF_WORK",
      "UPDATE_PUT_PLACE_OF_WORK",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode
      
      if (!this.editPlaceOfWork) {
        return;
      }

      if (typeof this.editPlaceOfWork === "object" && this.editPlaceOfWork !== null) {
        this.title = this.editPlaceOfWork;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============





    onCancel(){
      this.$route.params.editMode = false
    },
    onClose(){
      this.$route.params.editMode = false
    },




    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitMoney(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.placeOfWorkValidations.validate().then((success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }

      
        try {
          if (this.editPlaceOfWork.id) {

            this.UPDATE_PUT_PLACE_OF_WORK({
              id: this.editPlaceOfWork.id,
              title: this.title,
            }).then(async () => {
              await this.$parent.refresh()
            });
          } else {
        
            this.CREATE_PLACE_OF_WORK({title: this.title}).then(async () => {
              await this.$parent.refresh()
            });
          }
          this.$nextTick(() => {
            this.$route.params.editMode = false
            this.$bvModal.hide("modal-add-place-of-work");
          });

          this.title = {ru: '', uz: ''}

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============




  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
